import React from "react";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import { deleteLookupDetails, getServiceTypeUsed } from "../../Actions/lookupAPI";
import { toast } from "react-toastify";
import { DownloadAttachment } from "../../Actions/AttachmentAPI";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import Modal from 'react-bootstrap/Modal';
import swal from "sweetalert";
import i18n from "../DropdownLanguage/i18n";
import { Warning } from "@material-ui/icons";
import { OverlayTrigger, Popover } from "react-bootstrap";

let currentuser = JSON.parse(localStorage.getItem("currentUser"));

class CommonCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
      modalIsOpen: false,
      delete: ""
    };
  }

  ConfirmAlert(item) {
    const { dispatch } = this.props;
    dispatch({ type: "GetIntervalUsed", data: item })
    dispatch(getServiceTypeUsed(item.lookUpId));
    this.setState({ modalIsOpen: true })
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state[nodeName] = e.target.value;
    this.setState({});
  }

  render() {
    const { arraylist, pageSize, totalRecords, ServiceTypeUsed, IntervalUsed, t, currentPage } = this.props;
    const isArabic = i18n.language === 'arab'
    return (
      <div className="">
        <Modal
          size="md"
          show={this.state.modalIsOpen}
          onHide={() => this.setState({ modalIsOpen: false, delete: "" })}
          aria-labelledby="example-modal-sizes-title-sm"
          backdrop="static"
          centered="true"
          animation="true"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-sm">
              {t("confirmAlertMessage.DeleteMsg")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table style={{ width: '100%', wordBreak: "break-word" }}>
              <tr style={{ lineHeight: "30px" }} className={`${isArabic ? 'arabic' : ''}`}>
                <strong>{t("content.totalship")}  </strong><strong>:</strong><span>{ServiceTypeUsed ? ServiceTypeUsed.shipCount : 0}</span>
              </tr>
              <tr style={{ lineHeight: "30px" }} className={`${isArabic ? 'arabic' : ''}`}>
                <strong>{t("content.TotalEquipment")} </strong> <strong>:</strong><span>{ServiceTypeUsed ? ServiceTypeUsed.equipmentCount : 0}</span>
              </tr>
              <tr style={{ lineHeight: "30px" }}>
                <strong>{t("EquipmentManagementScreenContent.ShipNames")} : </strong><span>{ServiceTypeUsed ? ServiceTypeUsed.shipNames === null ? t('PendingApprovalScreenContent.NoShips') : ServiceTypeUsed.shipNames.toString() : ''}</span>
              </tr>
              <tr style={{ lineHeight: "30px" }}>
                <strong>{t("ShipEquipmentStatusScreen.EquipmentNames")} : </strong><span>{ServiceTypeUsed ? ServiceTypeUsed.equipmentNames === null ? t('PendingApprovalScreenContent.NoEquipments') : ServiceTypeUsed.equipmentNames.toString() : ''}</span>
              </tr>
              <span class="text-muted"><i>({t("EquipmentManagementScreenContent.DeleteNote")})</i></span>
              <br></br>
              <input
                className="form-control mt-2"
                style={{ width: "auto" }}
                type="text"
                name="delete"
                placeholder="Delete"
                onChange={(e) => this.handleInputChange(e)}
                value={this.state.delete}
              ></input>
              <div
                className="form-group search-btn-col mt-4"
                style={{ textAlign: "end" }}
              >
                <button
                  className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                  type="submit"
                  onClick={() => this.DeleteLookup(IntervalUsed)}
                >
                  {" "}
                  {t("confirmAlertMessage.Ok")}{" "}
                </button>
                <button
                  className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                  type="button"
                  // onClick={() => this.ClearInput()}
                  onClick={() => this.setState({ modalIsOpen: false, delete: "" })}
                >
                  {" "}
                  {t("ComplianceandBudgetScreen.Cancel")}{" "}
                </button>
              </div>
            </table>
          </Modal.Body>
        </Modal>
        {this.renderCardData()}
        {arraylist && arraylist.length !== 0 ? (
          <Paginator
            className="mb-3"
            // first={this.state.first}
            first={currentPage}
            rows={pageSize}
            totalRecords={totalRecords}
            onPageChange={(e) => this.onPaginatorChange(e)}
          ></Paginator>
        ) : (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">
                !--{t("CommonText.NoItem")}--!

              </h6>
            </div>
          </div>
        )}
      </div>
    );
  }
  onPaginatorChange(event) {
    this.setState({
      first: event.first,
    });
    const { setUpdatedState } = this.props;
    setUpdatedState(event.page + 1);
  }
  renderCardData = () => {
    const { showSidePane, arraylist, titleName, t } = this.props;
    const isArabic = i18n.language === 'arab'

    return arraylist && arraylist.length
      ? arraylist.map((item, index) => {
        return (
          <div
            className="card mb-2"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div className="p-2">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div
                    className={
                      item.isDeleted
                        ? "col-sm-12 col-md-12 col-12 m-auto"
                        : "col-sm-9 col-md-10 col-9 m-auto"
                    }
                  >
                    <div className="row px-4">
                      <div className={"col-md-12"}>
                        <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                          <strong
                            style={{
                              textDecorationLine: item.isDeleted
                                ? "line-through"
                                : "none",
                            }}>
                            {titleName === "TypeofShip" ? `${t("TypeofShipScreen.Title")}` : titleName === "EquipmentType" ? `${t("EquipmentTypeScreen.Title")}` /* :titleName === "TypeofPort" ? "Type"  */ :
                              titleName === "Interval" ? `${t("IntervelScreen.Title")}` : titleName === "Category" ? `${t("CategoryScreen.Title")}` :
                                titleName === "Unit" ? `${t("UnitScreen.Title")}` : titleName === "Zone" ? `${t("ZoneScreen.Title")}` : titleName} {" "}

                          </strong>
                          <strong>:</strong>

                        </span>
                        <span
                          className="italicFont"
                          style={{
                            textDecorationLine: item.isDeleted
                              ? "line-through"
                              : "none",
                          }}
                        >
                          {item.lookUpName}
                        </span>
                      </div>
                    </div>
                  </div>
                  {!item.isDeleted ? (
                    <div
                      className={"col-md-2 col-sm-3 col-3 m-auto text-right"}
                    >
                      <div className="text-center">
                        <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 250, hide: 400 }}
                          overlay={this.renderedit()}
                        >
                          <i
                            className="fa fa-edit fa-lg click m-1"
                            aria-hidden="true"
                            onClick={() => this.ShowSidePanel(item)}
                            style={{ color: " #1a3464", fontSize: "1.8rem" }}
                          ></i>
                        </OverlayTrigger>
                        {titleName === "Interval" ? (
                          <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={this.renderdelete()}
                          >
                            <i
                              className="fa fa-trash click m-1"
                              aria-hidden="true"
                              style={{ color: " #1a3464", fontSize: "1.8rem" }}
                              onClick={() => this.ConfirmAlert(item)}
                            ></i></OverlayTrigger>) : (
                          <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={this.renderdelete()}
                          >
                            <i
                              className="fa fa-trash click m-1"
                              aria-hidden="true"
                              style={{ color: " #1a3464", fontSize: "1.8rem" }}
                              onClick={() => this.DeleteLookup(item)}
                            ></i></OverlayTrigger>

                        )}
                        {titleName === "Flag" ? (
                          <i
                            className="fa fa-download click px-1"
                            aria-hidden="true"
                            style={{ color: " #1a3464", fontSize: "1.6rem" }}
                            onClick={() =>
                              this.DownloadDoc(
                                item.attachmentName,
                                item.attachmentGuid
                              )
                            }
                          ></i>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="my-3"></div>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      })
      : null;
  };
  DeleteLookup = (item) => {
    const { match, dispatch, titleName, t } = this.props;
    const { params } = match;
    const { type } = params;
    
    if (titleName === "Interval") {
      if (this.state.delete === "") {
        // swal('Error!', 'Please type correct keyword "Delete" to continue', 'warning');

        swal({
          title: t('SwalError.ErrorTitle'),
          text: t('SwalError.DeleteKeywordMessage'),
          icon: 'warning',
          buttons: {
            confirm: {
              text: t('confirmAlertMessage.Ok')
            }
          }
        });
      }
      else if (this.state.delete === "Delete") {
        let lookup = {
          lookUpId: item.lookUpId,
          lookUpToUpdate:
            type === "Flag"
              ? "flag"
              : type === "Interval"
                ? "intervals"
                : "lookup",
          lookUpType:
            type === "Interval"
              ? "intervals"
              : type === "Category"
                ? "category"
                /*   : type === "Class"
                    ? "class" */
                : type === "TypeofShip"
                  ? "typeofship"
                  : type === "Unit"
                    ? "unit"
                    : type === "Zone"
                      ? "zone"
                      /*  : type === "TypeofPort"
                       ? "typeofport" */
                      : "equipmentType",
          lookUpName: item.lookUpName,
          isDeleted: true,
          confirmDelete: this.state.delete,
          modifiedBy: currentuser.name,
        };
        dispatch(deleteLookupDetails(lookup, type,t));
        this.setState({ modalIsOpen: false, delete: "" })
        this.props.clearLookupName()
        
      }
      else {
        // swal('Error!', 'Please type correct keyword "Delete" to continue', 'warning');
        swal({
          title: t('SwalError.ErrorTitle'),
          text: t('SwalError.DeleteKeywordMessage'),
          icon: 'warning',
          buttons: {
            confirm: {
              text: t('confirmAlertMessage.Ok')
            }
          }
        });
      }
    }
    else {
      confirmAlert({
        message: t('confirmAlertMessage.DeleteMsg'),
        buttons: [
          {
            label: t('confirmAlertMessage.Yes'),
            onClick: () => {
              let lookup = {
                lookUpId: item.lookUpId,
                lookUpType:
                  type === "Interval"
                    ? "intervals"
                    : type === "Category"
                      ? "category"
                      /*  : type === "Class"
                         ? "class" */
                      : type === "TypeofShip"
                        ? "typeofship"
                        : type === "Unit"
                          ? "unit"
                          : type === "Zone"
                            ? "zone"
                            /*  : type === "TypeofPort"
                             ? "typeofport" */
                            : "equipmentType",
                lookUpToUpdate:
                  type === "Flag"
                    ? "flag"
                    : type === "Interval"
                      ? "intervals"
                      : "lookup",
                lookUpName: item.lookUpName,
                isDeleted: true,
                modifiedBy: currentuser.name,
              };
              dispatch(deleteLookupDetails(lookup, type, t));
              this.props.clearLookupName()
              
            },
          },
          {
            label: t('confirmAlertMessage.No'),
            onClick: () => { },
          },
        ],
      });
    }
  };

  renderedit(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label style={{ padding: "0px 10px" }}>{this.props.t("IntervelScreen.Edit")}</label>
        </Popover.Content>
      </Popover>
    );
  }

  renderdelete(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label style={{ padding: "0px 10px" }}>{this.props.t("CommonText.Delete")}</label>
        </Popover.Content>
      </Popover>
    );
  }


  DownloadDoc(attachmentName, attachmentGuid) {
    this.props.dispatch(DownloadAttachment(attachmentName, attachmentGuid));
  }
  ShowSidePanel = (item) => {
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.dispatch({ type: "getLookupDetails", data: item });
    this.props.history.push(
      `/Home/Lookup/${this.props.titleName}/Edit/${item.lookUpId}`
    );
  };
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    ServiceTypeUsed: state.lookupReducer.ServiceTypeUsed,
    IntervalUsed: state.lookupReducer.IntervalUsed
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CommonCard)
));
